import { RadioItemCombinedProps } from './types';

const usePresenter = (props: RadioItemCombinedProps): RadioItemCombinedProps => {
  return props;
};

export default usePresenter;
